var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcEmpujeInventario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.61,28.14H41.16V11.39A1.86,1.86,0,0,0,39.3,9.53H20.7a1.86,1.86,0,0,0-1.86,1.86V28.14H11.39A1.86,1.86,0,0,0,9.53,30V48.61a1.88,1.88,0,0,0,1.86,1.86H48.61a1.88,1.88,0,0,0,1.86-1.86V30a1.86,1.86,0,0,0-1.86-1.86Zm-26-14.88H37.44V28.14H22.56Zm-9.3,18.6H28.14V46.74H13.26ZM46.74,46.74H31.86V31.86H46.74Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.56,35.58H18.84a1.86,1.86,0,0,0-1.61.93,1.86,1.86,0,0,0,1.61,2.79h3.72a1.85,1.85,0,0,0,1.61-.93,1.86,1.86,0,0,0-1.61-2.79Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.58,37.44a1.86,1.86,0,0,0,1.86,1.86h3.72a1.86,1.86,0,0,0,1.61-2.79,1.86,1.86,0,0,0-1.61-.93H37.44a1.88,1.88,0,0,0-1.86,1.86Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.72,18.84A1.84,1.84,0,0,0,31.86,17H28.14a1.84,1.84,0,0,0-1.61.93,1.86,1.86,0,0,0,1.61,2.79h3.72a1.88,1.88,0,0,0,1.32-.55A1.85,1.85,0,0,0,33.72,18.84Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcEmpujeInventario);
export default __webpack_public_path__ + "static/media/DC__Empuje_inventario.f3c0ede9b72b9b8a3f30951b07da4146.svg";
export { ForwardRef as ReactComponent };